export const SENT_HOME_REQUEST_SUCCESS_MESSAGE_OPTION = {
  toastName: "fcf_success_toast",
  header: "Your request has been sent",
  message:
    "The shift will remain in your calendar until the workplace confirms your sent home request.",
  duration: 5000,
};

export enum TIMESHEET_TYPE {
  PHOTO = "photo",
  CDPH530 = "CDPH-530",
}

export enum SIGNED_TYPE {
  HCP = "HCP",
  HCF = "HCF",
}

// Keep in sync with MINIMUM_TIME_FOR_MANDATORY_BREAK_IN_HOURS at backend-main/src/modules/shifts/constants.ts
export const MINIMUM_TIME_FOR_MANDATORY_BREAK_IN_HOURS = 6;
